import PromptRouter3 from './PromptRouter3'
import PromptRouter3Custom from './PromptRouter3Custom'


export default PromptRouter3Custom

export  { PromptRouter3Custom, PromptRouter3 }
